(() => {
  const CONSENT_ATTRIBUTES = {
    'Akceptacja regulaminu i polityki prywatności': '',
    'Potwierdzenie pełnoletności': '',
  };

  function cartUpdateUrl() {
    return window.Theme?.routes?.cart_update_url || '/cart/update.js';
  }

  async function saveConsent() {
    const acceptedAt = new Date().toISOString();
    const attributes = {
      ...CONSENT_ATTRIBUTES,
      'Akceptacja regulaminu i polityki prywatności': `Zaakceptowano — ${acceptedAt}`,
      'Potwierdzenie pełnoletności': `Tak — ${acceptedAt}`,
    };
    const response = await fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) throw new Error('Consent update failed');
    return response;
  }

  if (!customElements.get('helga-purchase-consent')) {
    customElements.define(
      'helga-purchase-consent',
      class HelgaPurchaseConsent extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.dialog = this.querySelector('[data-ho-consent-dialog]');
          this.checkbox = this.querySelector('[data-ho-policy-consent]');
          this.confirmButton = this.querySelector('[data-ho-consent-confirm]');
          this.error = this.querySelector('[data-ho-consent-error]');
          this.productTitle = this.querySelector('[data-ho-consent-product-title]');
          this.productImage = this.querySelector('[data-ho-consent-product-image]');
          this.pendingAction = null;
          this.lastFocusedElement = null;

          this.querySelectorAll('[data-ho-consent-close]').forEach((button) => {
            button.addEventListener('click', () => this.close());
          });
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog?.addEventListener('close', () => {
            this.pendingAction = null;
            this.unlockPage();
          });
          this.checkbox?.addEventListener('change', () => this.updateState());
          this.confirmButton?.addEventListener('click', () => this.confirmAndContinue());
        }

        productData(source) {
          const section = source.closest('.shopify-section, .product-information, product-card, quick-add-component');
          const productForm =
            source.closest('product-form-component') ||
            section?.querySelector('product-form-component[data-consent-product-title]');
          const quickAdd = source.closest('quick-add-component');
          const titleElement = section?.querySelector(
            '[data-testid="sticky-product-title"], .view-product-title a, product-title a, product-title, h1, h2, h3'
          );
          const imageElement = section?.querySelector(
            '.product-information__media img, .product-card img, product-card img, img'
          );

          return {
            title:
              source?.dataset.consentProductTitle ||
              productForm?.dataset.consentProductTitle ||
              quickAdd?.dataset.productTitle ||
              titleElement?.textContent?.trim() ||
              'Wybrana usługa',
            imageUrl:
              source?.dataset.consentProductImage ||
              productForm?.dataset.consentProductImage ||
              imageElement?.currentSrc ||
              imageElement?.src ||
              '',
            imageAlt: imageElement?.alt || '',
          };
        }

        openForSource(source, action) {
          if (!this.dialog || typeof action !== 'function') return;
          const product = this.productData(source);
          this.pendingAction = action;
          this.lastFocusedElement = document.activeElement;

          if (this.productTitle) this.productTitle.textContent = product.title;
          if (this.productImage) {
            if (product.imageUrl) {
              this.productImage.src = product.imageUrl;
              this.productImage.alt = product.imageAlt || product.title;
              this.productImage.hidden = false;
            } else {
              this.productImage.hidden = true;
              this.productImage.removeAttribute('src');
            }
          }

          if (this.checkbox) this.checkbox.checked = false;
          if (this.error) {
            this.error.hidden = true;
            this.error.textContent = this.error.dataset.defaultMessage || '';
          }
          this.updateState();

          document.body.classList.add('ho-consent-open');
          if (!this.dialog.open) this.dialog.showModal();
          this.querySelector('[data-ho-consent-close]')?.focus();
        }

        close() {
          this.pendingAction = null;
          if (this.dialog?.open) this.dialog.close();
          this.lastFocusedElement?.focus?.();
        }

        unlockPage() {
          document.body.classList.remove('ho-consent-open');
        }

        updateState() {
          const accepted = Boolean(this.checkbox?.checked);
          if (this.confirmButton) {
            this.confirmButton.disabled = !accepted;
            this.confirmButton.setAttribute('aria-disabled', String(!accepted));
          }
          if (accepted && this.error) this.error.hidden = true;
        }

        async confirmAndContinue() {
          if (!this.checkbox?.checked) {
            if (this.error) {
              this.error.hidden = false;
              this.error.setAttribute('tabindex', '-1');
              this.error.focus();
            }
            return;
          }

          const action = this.pendingAction;
          if (typeof action !== 'function') return;
          this.confirmButton.disabled = true;
          this.setAttribute('aria-busy', 'true');

          try {
            await saveConsent();
            this.pendingAction = null;
            if (this.dialog?.open) this.dialog.close();
            window.requestAnimationFrame(action);
          } catch (error) {
            if (this.error) {
              this.error.textContent = 'Nie udało się zapisać potwierdzenia. Spróbuj ponownie.';
              this.error.hidden = false;
            }
            this.updateState();
          } finally {
            this.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  function consentElement() {
    return document.querySelector('helga-purchase-consent');
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const addButton = event.target.closest(
        'product-form-component form[data-type="add-to-cart-form"] button[type="submit"][name="add"]'
      );
      const bundleAction = event.target.closest(
        '.bundler-target-element button, .bundler-target-element a[role="button"], .bundler-target-element input[type="submit"]'
      );
      const source = addButton || bundleAction;
      if (!(source instanceof HTMLElement)) return;

      if (addButton) {
        const form = addButton.closest('form[data-type="add-to-cart-form"]');
        if (!(form instanceof HTMLFormElement)) return;
        if (form.dataset.hoConsentApproved === 'true') return;
        if (!form.checkValidity()) return;

        const consent = consentElement();
        if (!consent?.openForSource) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        consent.openForSource(addButton, () => {
          form.dataset.hoConsentApproved = 'true';
          addButton.click();
          window.setTimeout(() => delete form.dataset.hoConsentApproved, 2000);
        });
        return;
      }

      if (source.dataset.hoConsentApproved === 'true') {
        delete source.dataset.hoConsentApproved;
        return;
      }

      const consent = consentElement();
      if (!consent?.openForSource) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      consent.openForSource(source, () => {
        source.dataset.hoConsentApproved = 'true';
        source.click();
        window.setTimeout(() => delete source.dataset.hoConsentApproved, 2000);
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      const form = event.target;
      if (!form.matches('form[data-type="add-to-cart-form"]') || !form.closest('product-form-component')) return;

      if (form.dataset.hoConsentApproved === 'true') {
        delete form.dataset.hoConsentApproved;
        return;
      }

      const consent = consentElement();
      if (!consent?.openForSource) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitter = event.submitter;
      consent.openForSource(submitter instanceof HTMLElement ? submitter : form, () => {
        form.dataset.hoConsentApproved = 'true';
        if (submitter instanceof HTMLElement && submitter.isConnected) form.requestSubmit(submitter);
        else form.requestSubmit();
      });
    },
    true
  );

  function cartScope(container) {
    return container.closest('cart-drawer-component, .cart-page__summary, .cart__summary') || document;
  }

  function setCartConsentState(container, accepted) {
    container.dataset.hoCartConsentAccepted = String(accepted);
    cartScope(container)
      .querySelectorAll('[data-ho-consent-checkout], button[name="checkout"]')
      .forEach((button) => {
        button.disabled = !accepted;
        button.setAttribute('aria-disabled', String(!accepted));
      });
  }

  function initializeCartConsent(root = document) {
    root.querySelectorAll?.('[data-ho-cart-consent]').forEach((container) => {
      const checkbox = container.querySelector('[data-ho-cart-policy-consent]');
      setCartConsentState(container, Boolean(checkbox?.checked));
    });
  }

  document.addEventListener('change', async (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-ho-cart-policy-consent]')) return;
    const checkbox = event.target;
    const container = checkbox.closest('[data-ho-cart-consent]');
    if (!container) return;
    const error = container.querySelector('[data-ho-cart-consent-error]');

    if (!checkbox.checked) {
      setCartConsentState(container, false);
      return;
    }

    checkbox.disabled = true;
    try {
      await saveConsent();
      setCartConsentState(container, true);
      if (error) error.hidden = true;
    } catch (exception) {
      checkbox.checked = false;
      setCartConsentState(container, false);
      if (error) error.hidden = false;
    } finally {
      checkbox.disabled = false;
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const checkout = event.target.closest('[data-ho-consent-checkout], button[name="checkout"]');
      if (!checkout) return;
      const scope = checkout.closest('cart-drawer-component, .cart-page__summary, .cart__summary') || document;
      const container = scope.querySelector('[data-ho-cart-consent]');
      if (!container || container.dataset.hoCartConsentAccepted === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const error = container.querySelector('[data-ho-cart-consent-error]');
      if (error) {
        error.hidden = false;
        error.setAttribute('tabindex', '-1');
        error.focus();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    initializeCartConsent();
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        initializeCartConsent();
        scheduled = false;
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
